var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"popper-class":"app-popover","trigger":"click"}},[_c('ul',{staticClass:"app-list"},[_vm._t("list")],2),_c('el-button',{staticClass:"app-popover__btn",attrs:{"slot":"reference"},slot:"reference"},[_c('DotsVerticalIcon')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }